/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisputePenalty } from './DisputePenalty';
import {
    DisputePenaltyFromJSON,
    DisputePenaltyFromJSONTyped,
    DisputePenaltyToJSON,
    DisputePenaltyToJSONTyped,
} from './DisputePenalty';
import type { DisputeEvidence } from './DisputeEvidence';
import {
    DisputeEvidenceFromJSON,
    DisputeEvidenceFromJSONTyped,
    DisputeEvidenceToJSON,
    DisputeEvidenceToJSONTyped,
} from './DisputeEvidence';
import type { DisputeResolutionOutcome } from './DisputeResolutionOutcome';
import {
    DisputeResolutionOutcomeFromJSON,
    DisputeResolutionOutcomeFromJSONTyped,
    DisputeResolutionOutcomeToJSON,
    DisputeResolutionOutcomeToJSONTyped,
} from './DisputeResolutionOutcome';
import type { DisputeStatus } from './DisputeStatus';
import {
    DisputeStatusFromJSON,
    DisputeStatusFromJSONTyped,
    DisputeStatusToJSON,
    DisputeStatusToJSONTyped,
} from './DisputeStatus';
import type { DisputeReason } from './DisputeReason';
import {
    DisputeReasonFromJSON,
    DisputeReasonFromJSONTyped,
    DisputeReasonToJSON,
    DisputeReasonToJSONTyped,
} from './DisputeReason';

/**
 * A dispute filed for a tournament match
 * @export
 * @interface MatchDispute
 */
export interface MatchDispute {
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof MatchDispute
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof MatchDispute
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    tournamentId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    matchResultId?: string;
    /**
     * User ID who filed the dispute
     * @type {string}
     * @memberof MatchDispute
     */
    disputedBy: string;
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    disputingTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    opposingTeamId?: string;
    /**
     * 
     * @type {DisputeReason}
     * @memberof MatchDispute
     */
    reason: DisputeReason;
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    description?: string;
    /**
     * 
     * @type {Array<DisputeEvidence>}
     * @memberof MatchDispute
     */
    evidence?: Array<DisputeEvidence>;
    /**
     * 
     * @type {DisputeStatus}
     * @memberof MatchDispute
     */
    status: DisputeStatus;
    /**
     * 
     * @type {DisputeResolutionOutcome}
     * @memberof MatchDispute
     */
    resolution?: DisputeResolutionOutcome;
    /**
     * Admin user ID who resolved
     * @type {string}
     * @memberof MatchDispute
     */
    resolvedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchDispute
     */
    resolvedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchDispute
     */
    adminNotes?: string;
    /**
     * 
     * @type {Array<DisputePenalty>}
     * @memberof MatchDispute
     */
    penalties?: Array<DisputePenalty>;
    /**
     * DISPUTE-type ChatChannel for disputant/admin discussion
     * @type {string}
     * @memberof MatchDispute
     */
    chatChannelId?: string;
}



/**
 * Check if a given object implements the MatchDispute interface.
 */
export function instanceOfMatchDispute(value: object): value is MatchDispute {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('disputedBy' in value) || value['disputedBy'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MatchDisputeFromJSON(json: any): MatchDispute {
    return MatchDisputeFromJSONTyped(json, false);
}

export function MatchDisputeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchDispute {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'tournamentId': json['tournamentId'],
        'matchId': json['matchId'],
        'matchResultId': json['matchResultId'] == null ? undefined : json['matchResultId'],
        'disputedBy': json['disputedBy'],
        'disputingTeamId': json['disputingTeamId'] == null ? undefined : json['disputingTeamId'],
        'opposingTeamId': json['opposingTeamId'] == null ? undefined : json['opposingTeamId'],
        'reason': DisputeReasonFromJSON(json['reason']),
        'description': json['description'] == null ? undefined : json['description'],
        'evidence': json['evidence'] == null ? undefined : ((json['evidence'] as Array<any>).map(DisputeEvidenceFromJSON)),
        'status': DisputeStatusFromJSON(json['status']),
        'resolution': json['resolution'] == null ? undefined : DisputeResolutionOutcomeFromJSON(json['resolution']),
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : json['resolvedAt'],
        'adminNotes': json['adminNotes'] == null ? undefined : json['adminNotes'],
        'penalties': json['penalties'] == null ? undefined : ((json['penalties'] as Array<any>).map(DisputePenaltyFromJSON)),
        'chatChannelId': json['chatChannelId'] == null ? undefined : json['chatChannelId'],
    };
}

export function MatchDisputeToJSON(json: any): MatchDispute {
    return MatchDisputeToJSONTyped(json, false);
}

export function MatchDisputeToJSONTyped(value?: MatchDispute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'tournamentId': value['tournamentId'],
        'matchId': value['matchId'],
        'matchResultId': value['matchResultId'],
        'disputedBy': value['disputedBy'],
        'disputingTeamId': value['disputingTeamId'],
        'opposingTeamId': value['opposingTeamId'],
        'reason': DisputeReasonToJSON(value['reason']),
        'description': value['description'],
        'evidence': value['evidence'] == null ? undefined : ((value['evidence'] as Array<any>).map(DisputeEvidenceToJSON)),
        'status': DisputeStatusToJSON(value['status']),
        'resolution': DisputeResolutionOutcomeToJSON(value['resolution']),
        'resolvedBy': value['resolvedBy'],
        'resolvedAt': value['resolvedAt'],
        'adminNotes': value['adminNotes'],
        'penalties': value['penalties'] == null ? undefined : ((value['penalties'] as Array<any>).map(DisputePenaltyToJSON)),
        'chatChannelId': value['chatChannelId'],
    };
}

